var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigate-user-wrapper",on:{"~click":function($event){return _vm.navigate.apply(null, arguments)}}},[_c('img',{attrs:{"src":require("@/assets/back-arrow.png")}}),_c('h2',[_vm._v(_vm._s(_vm.$t("message.continueOrdering")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }